exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".text-slider-up-wrap{height:24px}.text-slider-up-wrap .slider-box{position:relative;width:100%;height:24px}.text-slider-up-wrap ul li.slider-item{color:#ceeaff;font-size:16px;display:block;height:24px;line-height:24px;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;position:absolute;top:0;opacity:0}.text-slider-up-wrap .text-show{animation:textSliderShow .6s linear forwards}.text-slider-up-wrap .text-hide{animation:textSliderHide .6s linear forwards}@keyframes textSliderShow{0%{top:24px;opacity:0}to{top:0;opacity:1}}@keyframes textSliderHide{0%{top:0;opacity:1}to{top:-24px;opacity:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-7a0c5b48!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/charts/text-slider/index.vue
// module id = 176
// module chunks = 0